import { combineReducers } from "redux";

import { theme } from "commons/src/reducers/themeReducers";
import { user } from "commons/src/reducers/clientPortalUserReducer";
import { getRootReducer } from "commons/src/reducers/indexReducer";
import { documents } from "commons/src/reducers/documentsReducers";
import { accounts } from "commons/src/reducers/accountsReducers";
import { analysis } from "commons/src/reducers/analysisReducers";

import { adviser } from "./adviserReducers";
import { addresses } from "./addressesReducers";
import { bankAccounts } from "./bankAccountsReducers";
import { memoAssets } from "./memoAssetsReducers";
import { navigation } from "./navigationReducers";
import { news } from "./newsReducers";
import { requests } from "./requestsReducers";
import { applicationContext } from "./applicationContextReducers";

const appReducer = combineReducers({
    accounts,
    addresses,
    adviser,
    analysis,
    bankAccounts,
    documents,
    memoAssets,
    navigation,
    news,
    requests,
    theme,
    applicationContext,
    user
});

export const rootReducer = getRootReducer(appReducer);
